import React, { useState } from 'react'
import { useRecentOrdersContext } from '../../Context/Cache/RecentOrder/RecentOrdersContext'
import { useQuoteOfferContext } from '../../Context/Cache/QuoteOffers/QuoteOfferContext'
import recentOrderImage from '../Assets/icon/recent-order.png'
import quoteImage from '../Assets/icon/quote.png'
 
const RecentOffersSlider = () => {
  const { isExpanded, setIsExpanded, toggleWidth, fetchSalesOrders,recentCacheName } = useRecentOrdersContext()
  const { activePage, setPage } = useQuoteOfferContext()
  const [activeAccordion, setActiveAccordion] = useState(null);
 
    const handleRefershOrder = async() => {
            console.log("Button Clicked");
            caches.delete(recentCacheName);
            setPage('recentOrder')
            await fetchSalesOrders()
    }
  return (
    <div className="order-2 order-lg-1" style={{ width: !isExpanded ? `370px` : `0px` }}>
      <div className="">
        <div className="filter-group">
          <button
            className={`accordionRecent ${activeAccordion === 3 ? "active" : ""}`}
            onClick={() => setPage('quote')}
          >
            <div className='flex gap-1 items-center'>
              <img src={quoteImage} alt="" style={{ width: '19px', height: '22px' }} />
              Offers
            </div>
          </button>
        </div>
        <div className="filter-group">
          <button
            className={`accordionRecent ${activeAccordion === 3 ? "active" : ""}`}
            onClick={() => handleRefershOrder()}
          >
            <div className='flex gap-1 items-center'>
              <img src={recentOrderImage} alt="" style={{ width: '19px', height: '22px' }} />
              Recent Orders
            </div>
          </button>
        </div>
        {/* <div className="filter-group">
          <button
            className={`accordionRecent ${activeAccordion === 3 ? "active" : ""}`}
            onClick={() => setPage('recentOrder1')}
          >
            <div className='flex gap-1 items-center'>
              <img src={recentOrderImage} alt="" style={{ width: '19px', height: '22px' }} />
              Recent Orders 1.0
            </div>
          </button>
        </div> */}
      </div>
    </div>
  )
}
 
export default RecentOffersSlider